import { render, staticRenderFns } from "./SearchShiftDialog.vue?vue&type=template&id=31632c63&scoped=true"
import script from "./SearchShiftDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchShiftDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchShiftDialog.vue?vue&type=style&index=0&id=31632c63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31632c63",
  null
  
)

export default component.exports